<template>
  <section class="email-comparison-modal">
    <modal-template>
      <template #card-title>
        <slot name="card-title">
          Mijn vergelijking bewaren
        </slot>
      </template>
      <template #comparison-data>
        <div
          v-if="computedComparison.location_object"
          class="usp"
        >
          <icon icon="x-fa-house" />
          <span>{{ computedComparison.location_object.display }}</span>
        </div>
        <slot name="market-usps" />
      </template>
      <template #content>
        <slot name="modal-content">
          We sturen de vergelijking direct naar je e-mailadres. Je kunt hem ook terugvinden door met je e-mail in te
          loggen op Mijn Keuze.
        </slot>
      </template>
      <template #inputs>
        <div class="email-comparison-inputs">
          <TextInput
            id="first_name"
            v-model.lazy="computedComparison.first_name"
            :error="error.first_name"
            label="Naam"
          />
          <email-field-element
            v-model:value="computedComparison.email_address"
            type="text"
            name="email_address"
            placeholder="Jouw e-mailadres"
            :label="{text: 'E-mailadres'}"
            :state="{text:error.email_address}"
            lazy
            :pattern="null"
            @keydown.native.enter="saveComparison"
          />
          <TextInput
            id="email_address"
            v-model.lazy="computedComparison.email_address"
            :error="error.email_address"
            label="E-mailadres"
          />
          <TextInput
            id="remarks"
            v-model.lazy="computedComparison.remarks"
            :error="error.remarks"
            label="Korte beschrijving"
          />
        </div>
        <div class="alert-signup">
          <input-checkbox-default
            v-model:value="computedComparison.subscribe_mail_campaigns"
            :label="`${marketType === 'energy'?'Ik wil bespaartips en een melding als energie goedkoper wordt.':'Ik wil af en toe handige bespaartips ontvangen.'}`"
            name="alert-signup"
          />
          <button-icon-right
            type="cta"
            label="Bewaar voor later"
            @click.native="saveComparison"
          />
        </div>
      </template>
    </modal-template>
  </section>
</template>

<script>

import Icon from 'vue-elements/icon/Icon.vue';
import CardDefault from '../../../elements/card/default/cardDefault.vue';
import TextFieldElement from '../../../elements/field/text/default/textDefault.vue';
import ButtonIconRight from '../../../elements/button/icon-right/button-icon-right.vue';
import ModalTemplate from '../shared/ModalTemplate.vue';
import InputCheckboxDefault from '../../../elements/input/checkbox/default/checkboxDefault.vue';
import saveComparisonModal from '../assets/js/saveComparisonModal.js';
import EmailFieldElement from '../../../elements/field/email/default/emailDefault.vue';
import TextInput from '../../../../templates/vue-elements/input/TextInput.vue';

export default {
    name: 'EmailComparisonModal',
    components: {
        TextInput,
        InputCheckboxDefault,
        ModalTemplate,
        ButtonIconRight,
        TextFieldElement,
        CardDefault,
        Icon,
        EmailFieldElement,
    },
    mixins: [saveComparisonModal],

};
</script>
